import { Seo } from "../components/Seo";
import { Link } from "react-router-dom";
import { Home, Search, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { VG_ORANGE } from "../lib/brand";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center px-4 py-20">
      <Seo title="Page Not Found" description="The page you're looking for could not be found. Explore van Gelder, Inc. commercial flooring products and resources." />
      <div className="max-w-xl text-center">
        <p
          className="font-heading text-[7rem] leading-none font-extrabold tracking-tight sm:text-[9rem]"
          style={{ color: "#307fbf" }}
        >
          404
        </p>
        <h1 className="mt-2 font-heading text-3xl font-extrabold text-neutral-900 sm:text-4xl">
          Page not found
        </h1>
        <p className="mt-4 text-base text-neutral-600">
          The link you followed may be broken, or the page may have been moved. Let's get you back to
          the right place.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            asChild
            className="text-white hover:opacity-90"
            style={{ backgroundColor: VG_ORANGE }}
            data-testid="notfound-home-btn"
          >
            <Link to="/">
              <Home className="mr-2 h-4 w-4" /> Back to Home
            </Link>
          </Button>
          <Button asChild variant="outline" data-testid="notfound-products-btn">
            <Link to="/products">
              <Search className="mr-2 h-4 w-4" /> Browse Products
            </Link>
          </Button>
          <Button asChild variant="outline" data-testid="notfound-contact-btn">
            <Link to="/contact">
              <Phone className="mr-2 h-4 w-4" /> Contact Us
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
